import { StorageKeys, localStorageService } from '../storage/storageService';

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export const getIsFullStoryEnabled = (fullStorySampleRate: number) => {
  try {
    const timestamp = Date.now();
    const storeValue: boolean = localStorageService.get(StorageKeys.LOCAL_STORE_FULLSTORY_FLAG);
    const storeTime: number = localStorageService.get(StorageKeys.LOCAL_STORE_FULLSTORY_TIMESTAMP);

    // if was enabled recently than keep enabled for 1 day
    if (storeValue && storeTime + ONE_DAY_IN_MS > timestamp) {
      return storeValue === true;
    }

    const isFullStoryEnabled = Math.random() < fullStorySampleRate;

    localStorageService.set(StorageKeys.LOCAL_STORE_FULLSTORY_FLAG, isFullStoryEnabled);
    localStorageService.set(StorageKeys.LOCAL_STORE_FULLSTORY_TIMESTAMP, timestamp);

    return isFullStoryEnabled;
  } catch (e) {
    return false;
  }
};
